const capitalizeFirstLetter = (word) => {
    if (word) {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }
};

export default capitalizeFirstLetter;
